import { ReactElement } from "react";
import { SecondaryButton } from "../secondaryButton/secondaryButton";
import "./PopupForms.scss";

export function PopupForms (props: {
    buttonSecondaryFunction: Function,
    children?:ReactElement<any, any>
}) {
    return (
        <div className="gno-popup-forms-wrapper">
            <div className="gno-popup-forms-container">
                <p className="gno-popup-forms-headline">{"Formulare & mehr"}</p>
                <div className="gno-popup-forms-content">
                    {props.children}
                </div>
                <div className="popup-forms-button-container">
                <SecondaryButton
                    text="Schließen"
                    function={props.buttonSecondaryFunction}
                    negative={false}
          />
                </div>
            </div>
        </div>
    )
}

export function Metalink (props: {linkText: string, function: Function}) {
    return(
        <div className="gno-metalink-container" onClick={() => {props.function()}}>
            <p className="gno-metalink-text">{props.linkText}</p>
        </div>
    )
}